import { useTranslation } from "react-i18next";
import { StatusCode } from "api/protocols";
import { ExportCustomerList as ClientExportCustomerList } from "api/rpc/2024-04/clientAdmin/customer/customer";
import { ExportCustomerList as FacilityExportCustomerList } from "api/rpc/2024-04/facilityAdmin/customer/customer";
import Input from "components/form/input";
import Popup from "components/popup/Popup";
import { useAppDispatch } from "hooks/redux";
import React, { useState } from "react";
import { showError, showSuccess } from "redux/actions/ui";
import validator from "validator";

interface IExportCustomersProps {
  type: "client" | "facility";
  open: boolean;
  onClose: () => void;
  filter: {
    customer_type: number[];
    cart_customer_type: number[];
  };
}

export default function ExportCustomers({ open, onClose, filter, type }: IExportCustomersProps) {
  const { t } = useTranslation();
  const [exportEmail, setExportEmail] = useState({
    isDirty: false,
    isValid: false,
    value: "",
  });

  const dispatch = useAppDispatch();

  async function handleExportCustomerList() {
    if (!exportEmail.isValid) {
      dispatch(showError(t("Please enter a valid email address")));
      return;
    }
    const params = {
      customer_type: filter?.customer_type,
      cart_customer_type: filter?.cart_customer_type,
      email: exportEmail.value,
    };

    let exportRes = null;
    if (type === "facility") {
      exportRes = await FacilityExportCustomerList(params, true);
    } else if (type === "client") {
      exportRes = await ClientExportCustomerList(params, true);
    }
    console.log(exportRes, type);
    if (exportRes?.status !== StatusCode.OK) {
      dispatch(showError(t("Error exporting customers")));
      return;
    }

    dispatch(
      showSuccess(
        t("Successfully exported customer list."),
        10000,
        "Your exported list is on its way! Please note it may take a few minutes to arrive in your email.",
      ),
    );

    onClose();
  }

  return (
    <Popup
      type="export"
      open={open}
      title={t("Export customer list")}
      onCancel={onClose}
      onOk={() => handleExportCustomerList()}
      okText={t("Export")}
      okDisabled={!exportEmail.isValid || !exportEmail.isDirty || (exportEmail.isDirty && !exportEmail.isValid)}
      description={t("Enter your email to receive the customer list as a .CSV file.")}
    >
      <br />
      <Input
        type={"email"}
        label={t("Email")}
        value={exportEmail.value}
        onChange={e =>
          setExportEmail({ isDirty: true, isValid: validator.isEmail(e.target.value), value: e.target.value })
        }
        error={exportEmail.isDirty && !exportEmail.isValid}
      ></Input>
    </Popup>
  );
}
